import Myaxios from '../utils/myaxios'

export function importAgentRakeBackList(data) {
    return Myaxios({
        url: '/manager/profit/importAgentRakeBackList',
        data,
        method:'post'
    })
}

export function getRakeBackList(data) {
    return Myaxios({
        url: '/manager/profit/getRakeBackList',
        data,
        method:'post'
    })
}


export function getAgentSysCashOutList(data) {
    return Myaxios({
        url: '/manager/profit/getAgentSysCashOutList',
        data,
        method:'post'
    })
}

export function applySub(data) {
    return Myaxios({
        url: '/manager/profit/applySub',
        data,
        method: 'post'
    })
}

export function getCommission() {
    return Myaxios({
        url: '/manager/profit/getCommission'
    })
}


export function importTxList(data) {
    return Myaxios({
        url: '/manager/profit/importTxList',
        params: data
    })
}

export function checkSucc(data) {
    return Myaxios({
        url: '/manager/profit/checkSucc',
        data,
        method: 'post'
    })
}


export function plBatchPass(data) {
    return Myaxios({
        url: '/manager/profit/plBatchPass',
        data,
        method: 'post'
    })
}

export function plBatchNoPass(data) {
    return Myaxios({
        url: '/manager/profit/plBatchNoPass',
        data,
        method: 'post'
    })
}



export function isCheckData(data) {
    return Myaxios({
        url: '/manager/profit/getIdSysCashOut/'+data
    })
}

export function getProfitInfo(data) {
    return Myaxios({
        url: '/manager/profit/getProfitInfo/'+data
    })
}

export function getTxList(data) {
    return Myaxios({
        url: '/manager/profit/getSysCashOutList',
        params: data
    })
}

export function importFyList(data) {
    return Myaxios({
        url: '/manager/profit/importFyList',
        data,
        method:'post'
    })
}


export function getSumMoneySys(data) {
    return Myaxios({
        url: '/manager/profit/getSumMoneySys',
        data,
        method: 'post'
    })

}

export function getProfitDetail(data) {
    return Myaxios({
        url: '/manager/profit/getSysProfitDetails',
        data,
        method: 'post'
    })

}

export function setAgentProfit(data) {
    return Myaxios({
        url: '/manager/ag-pac/sa-pac',
        data,
        method: 'POST'
    })
}